import About from "../../components/about/about/About.tsx";

function AboutPage() {
    return (
        <>
            <About />
        </>
    )
}

export default About;